import { render, staticRenderFns } from "./SoldItemsByFiliale.vue?vue&type=template&id=416b2dc8&scoped=true"
import script from "./SoldItemsByFiliale.vue?vue&type=script&lang=js"
export * from "./SoldItemsByFiliale.vue?vue&type=script&lang=js"
import style0 from "./SoldItemsByFiliale.vue?vue&type=style&index=0&id=416b2dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416b2dc8",
  null
  
)

export default component.exports